<template>
  <v-layout style="position: absolute; top: 0; left: 0px; right: 0; bottom: 0;" v-if="resource">
    <!-- <v-btn @click="updateSource">Fetch it now</v-btn> -->
    <v-row
      class="pa-3"
      no-gutters
      style="position: absolute; left: 0; right: 70px; z-index: 2; pointer-events: none;"
    >
      <!-- <v-col>
        <v-menu>
          <template v-slot:activator="{ on: { click } }">
            <v-btn @click.stop="click" fab small color="white" style="pointer-events: all;">
              <div style="width: 22px; height: 22px; margin-left: -1px;">
                <div
                  style="display: inline-block; width: 50%; height: 100%; padding: 1px; overflow: hidden;"
                >
                  <div
                    style="background: grey; height: 100%; width: 100%; border-radius: 2px;"
                  ></div>
                </div>
                <div
                  style="display: inline-block; width: 50%; height: 100%; padding: 1px; overflow: hidden;"
                >
                  <div
                    style="background: grey; height: 100%; width: 100%; border-radius: 2px;"
                  ></div>
                </div>
              </div>
            </v-btn>
          </template>
          <v-list>
            <template>
              <v-list-item @click="">
                <v-list-item-icon><v-icon>add_to_photos</v-icon></v-list-item-icon>
                <v-list-item-title>Group notes in new page</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="">
                <v-list-item-icon><v-icon>close</v-icon></v-list-item-icon>
                <v-list-item-title>Delete Selected Notes</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </v-col> -->
      <v-col v-if="ready">
        <v-btn
          v-if="!screenCaptureMode"
          fab
          small
          @click="screenCaptureMode = true"
          color="white"
          style="pointer-events: all;"
          ><v-icon>add_a_photo</v-icon>
        </v-btn>
        <v-btn
          v-else-if="screenCaptureMode"
          @click="
            screenCaptureMode = false;
            captureSelection = {
              showBtn: false,
              imageUrl: false,
              position: {}
            };
          "
          color=""
          style="pointer-events: all;"
          >Exit Screen Capture</v-btn
        >
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="shrink">
        <v-btn fab small @click="$emit('close')" style="pointer-events: all;">
          <v-icon>close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-col
      class="pa-0"
      :style="
        `overflow-y: auto;
          position: relative;
              overflow-x: hidden;
              height: 100%;`
      "
    >
      <div v-if="fetching">LOADING SOURCE!</div>
      <template v-else-if="resource.resourceData.type == 'webpage'">
        <webpage-module
          :screenCaptureMode="screenCaptureMode"
          :captureSelection="captureSelection"
          :resource="resource"
          ref="contentModule"
          @scrollTo="$vuetify.goTo($event - 10, { container: '.wrapper' })"
          @updateCaptureSelection="captureSelection = $event"
          @updateScreenCaptureMode="screenCaptureMode = $event"
          @addedExcerpt="copyToClipboard"
          @saveExcerpt="saveExcerpt"
          @saveScreen="saveScreen"
          @ready="ready = true"
          :userCanEdit="userCanEdit"
        ></webpage-module>
      </template>
      <pdf-module
        v-else-if="resource.resourceData.type == 'pdf'"
        ref="contentModule"
        :resourceId="resourceId"
        :userCanEdit="userCanEdit"
        :screenCaptureMode="screenCaptureMode"
        :captureSelection="captureSelection"
        @selectExcerpt="scrollExcerpts"
        @saveExcerpt="saveExcerpt"
        @saveScreen="saveScreen"
        @updateCaptureSelection="captureSelection = $event"
        @updateScreenCaptureMode="screenCaptureMode = $event"
        @addedExcerpt="copyToClipboard"
        @ready="ready = true"
      ></pdf-module>
    </v-col>
    <v-col
      shrink
      class="elevation-1 grey lighten-4 pa-0"
      style="height: 100%; overflow-y: auto; max-width: 56px; overflow-x: hidden;"
    >
      <v-list dark style="height: 100%;">
        <resource-details
          v-model="showCard"
          :resource="resource"
          :userCanEdit="userCanEdit"
        ></resource-details>
        <resource-excerpts
          v-model="showCard"
          ref="resourceExcerpts"
          :resource="resource"
          :userCanEdit="userCanEdit"
          @scrollTo="scrollTo"
          @removedExcerpt="removeHighlight"
        ></resource-excerpts>
        <resource-notes
          v-model="showCard"
          :resource="resource"
          :userCanEdit="userCanEdit"
        ></resource-notes>
      </v-list>
    </v-col>
    <v-snackbar v-model="snackbar.show" color="info" right :timeout="5000" bottom>
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import PdfModule from './PDFModule';
import WebpageModule from './WebpageModule';
import ResourceDetails from './ResourceDetails';
import ResourceExcerpts from './ResourceExcerpts';
import ResourceNotes from './ResourceNotes';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: { PdfModule, WebpageModule, ResourceExcerpts, ResourceDetails, ResourceNotes },
  props: ['resourceId', 'fetch'],
  mounted() {
    console.log('subscribe');
    console.log(this.resourceId);
    // setTimeout(() => {
    //   this.showCard = 'details';
    // }, 500);
    this.fetchResource();
  },
  beforeDestroy() {
    console.log('destroy');
    if (this.subscription) {
      console.log('stop sub');
      this.subscription.stop();
    }
  },
  watch: {
    resourceId: function(n) {
      console.log('updated resourceId');
      this.fetching = true;
      this.ready = false;
      this.fetchResource();
    }
  },
  data() {
    return {
      fetching: true,
      loadingSrc: true,
      iframeLoaded: false,
      // resource: null,
      subscription: null,
      showCard: false,
      screenCaptureMode: false,
      ready: false,
      snackbar: { show: false, text: '' },
      captureSelection: {
        showBtn: false,
        position: {}
      }
    };
  },
  computed: {
    ...mapState('resources', ['resources']),
    ...mapGetters('userWorkspaceLite', ['workspaceResources']),
    ...mapGetters('auth', ['researchSession']),
    userCanEdit() {
      return !!this.workspaceResources.find(r => r.id == this.resourceId);
    },
    resource() {
      console.log('resource updated');
      return this.resources[this.resourceId] || false;
    }
  },
  methods: {
    ...mapActions('resources', [
      'subscribeToResource',
      'updateResourceSource',
      'addResourceToContext',
      'addExcerpt',
      'addScreenShotExcerpt'
    ]),
    ...mapActions('pages', ['addCardNote']),
    ...mapMutations('components/magicClipboard', ['setClipboard']),
    fetchResource() {
      if (!this.resources[this.resourceId]) {
        this.subscribeToResource({ resourceId: this.resourceId })
          .then(result => {
            console.log('subscribed');
            this.subscription = result;
            this.fetching = false;
          })
          .catch(e => console.log(e));
      } else {
        this.fetching = false;
      }
    },
    saveExcerpt({
      excerpt,
      resourceId,
      source,
      position,
      positions = [],
      pages = [],
      order = false,
      callback
    }) {
      if (excerpt.length) {
        this.addExcerpt({
          resourceId,
          excerpt,
          source,
          position,
          positions,
          pages,
          order
        })
          .then(clipId => {
            //  add to c
            this.copyToClipboard({ clipId, excerpt, resourceId: this.resource.id });
            // this.$emit('addedExcerpt', { clipId, excerpt, resourceId: this.resource.id });
            this.$nextTick(() => {
              callback(); //-->this.setHighlight(this.filteredResources); this.addBtn.show = false;
              //this.addBtn.text = '';
            });
          })
          .catch(e => {
            console.log('error saving excerpt', e);
          });
      }
    },
    saveScreen({ resourceId, excerptData, source, callback }) {
      this.addScreenShotExcerpt({
        resourceId,
        excerptData,
        source
      })
        .then(clipId => {
          console.log('copy addedExcerpt');
          this.copyToClipboard({ clipId, excerpt: 'Screen capture', resourceId });
          callback();
        })
        .catch(e => console.log(e));
    },
    copyToClipboard(data) {
      console.log('copy!', data);
      this.$copyText(data.excerpt);
      console.log(data.excerpt);
      this.setClipboard({ text: data.excerpt, type: 'clip', clipData: data });
      let text = 'Clip copied to Magic Clipboard';
      //  check research session
      if (this.researchSession.researching) {
        const { pageId, contextName, contextId, pageName } = this.researchSession;
        //  check if we need to add resource to context
        if (!this.resource.usedOn[contextId]) {
          //  add resouce to context
          this.addResourceToContext({
            resourceId: this.resource.id,
            contextId
          });
        }
        //  create note on page
        const widgetInfo = {
          widgetType: 'resource',
          widgetData: {
            resourceId: this.resource.id,
            resourceVersion: this.resource.version,
            resourceNoteIds: data.clipId ? [data.clipId] : []
          }
        };
        this.addCardNote({
          widgetInfo,
          pageId,
          type: 'widget'
        });

        text = `Pasted clip to ${pageName} in ${contextName}`;
      }
      this.snackbar = {
        show: true,
        text
      };
    },
    updateSource() {
      this.updateResourceSource({ resource: this.resource }).then(() => {
        this.getFilePath();
      });
    },
    scrollTo(id) {
      this.$refs.contentModule.scrollContent(id);
    },
    removeHighlight(id) {
      console.log('remove highlight', id);
      this.$refs.contentModule.removeHighlight(id);
    },
    scrollExcerpts(id) {
      this.showCard = 'excerpts';
      this.$nextTick(() => {
        this.$refs.resourceExcerpts.scrollTo(id);
      });
    }
  }
};
</script>

<style></style>
